import { render } from "./ApplicationsForSupportPage.vue?vue&type=template&id=ca2482c0"
import script from "./ApplicationsForSupportPage.vue?vue&type=script&lang=js"
export * from "./ApplicationsForSupportPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__